import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NetworkService } from '@core/network.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-offline-waiting',
  template: `
    <div class="offline-container">
      <h2>You're currently offline</h2>
      <p>We'll automatically continue when your connection is restored.</p>
      <div class="spinner"></div>
    </div>
  `,
  styles: [`
    .offline-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      text-align: center;
      padding: 20px;
    }
    h2 {
      margin-bottom: 16px;
      color: #333;
    }
    p {
      margin-bottom: 24px;
      color: #666;
    }
    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class OfflineWaitingComponent implements OnInit, OnDestroy {
  private networkSubscription: Subscription;
  private queryParams: { [key: string]: string | string[] };

  constructor(
    private networkService: NetworkService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.queryParams = this.route.snapshot.queryParams;
  }

  ngOnInit() {
    this.networkSubscription = this.networkService.isOnline()
      .pipe(filter(online => online))
      .subscribe(() => {
        // When we're back online, navigate back to quick-launch with original params
        this.router.navigate(['/quick-launch'], {
          queryParams: this.queryParams
        });
      });
  }

  ngOnDestroy() {
    if (this.networkSubscription) {
      this.networkSubscription.unsubscribe();
    }
  }
}